<div id="error-page">
    <div class="content">
        <h2 class="header">
            404
        </h2>
        <h4>
            Opps! Page not found
        </h4>
        <p>
            {{ message }}
        </p>
        <div class="btns">
            <a mat-raised-button color="primary" routerLink="/home">RETURN HOME</a>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/pagenotfound/pagenotfound.component.html